import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserRight } from 'src/app/core/_models/userRight';

@Component({
  selector: 'app-dialog-right-user',
  templateUrl: './dialog-right-user.component.html',
  styleUrls: ['./dialog-right-user.component.scss']
})
export class DialogRightUserComponent {
  profilesCode!: any[];
  typesPerimeter!: any[];
  perimeters!: any[];
  selectedRight!: UserRight;
  code!: string;

  constructor(
    public dialogRef: MatDialogRef<DialogRightUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.profilesCode = [...new Set(data?.userRights.map((x: any) => x?.profileCode))];
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getTypesPerimeter(code: string) {
    this.code = code;
    this.typesPerimeter = [...new Set(this?.data?.userRights.filter((x: any) => x.profileCode == code).map((x: any) => x.perimeterType))];
  }

  getPerimeters(perimeterType: string) {
    this.perimeters = [...new Set(this?.data?.userRights.filter((x: any) => x.perimeterType == perimeterType && x.profileCode == this.code))];
  }
}
